import React, { useState } from "react";
import { MainPolicySettingBlock, PolicyCustomizeSection, SubPolicySettingBlock } from "uis/Section";
import UI from "@mile-meeting/mile-ui";
import AlertModal from "uis/modal/alert-modal";

type PreMeetingNotificationSettingProps = {
  meetingReminderActive: boolean;
  meetingReminderTime: number;
  onChangeMeetingReminderActive: (active: boolean) => void;
  onChangeMeetingReminderTime: (time: number) => void;
};
const PreMeetingNotificationSetting: React.FC<PreMeetingNotificationSettingProps> = ({
  meetingReminderActive,
  meetingReminderTime,
  onChangeMeetingReminderActive,
  onChangeMeetingReminderTime,
}) => {
  const [meetingReminderActiveModal, setMeetingReminderActiveModal] = useState<boolean>(false);
  const [meetingReminderUnActiveModal, setMeetingReminderUnActiveModal] = useState<boolean>(false);

  return (
    <PolicyCustomizeSection title="예약 시작 전 알림 설정">
      <MainPolicySettingBlock
        title="예약 시작 전 알림 활성화"
        description="활성화 시 예약 시작 전, 참석자에게 이에 대한 알림을 전송합니다. "
        haveChildren={meetingReminderActive}
        rightChildren={
          <UI.Selection.Toggle.Default
            size="large"
            state={meetingReminderActive}
            onChange={(enabled) =>
              enabled ? setMeetingReminderActiveModal(true) : setMeetingReminderUnActiveModal(true)
            }
          />
        }
      />
      {meetingReminderActive && (
        <SubPolicySettingBlock
          title="예약 시작 전 알림 시간"
          description="예약 시작 시간 기준으로 설정한 시간 전, 참석자에게 예약 시작 안내를 전송합니다."
          rightChildren={
            <UI.SelectBox
              size="small"
              data={["5분", "10분", "15분", "20분", "25분", "30분", "35분", "40분", "45분", "50분", "55분", "60분"]}
              selectedData={[meetingReminderTime + "분"]}
              width={120}
              dropdownMaxHeight={120}
              onChange={(time: string[]) => onChangeMeetingReminderTime(Number(time[0].replaceAll("분", "")))}
            />
          }
        />
      )}
      <AlertModal
        title={<p>예약 시작 전 알림을 활성화하시겠습니까?</p>}
        content={<p style={{ textAlign: "center" }}>예약 시작 전, 참석자에게 사전 알림을 전송합니다.</p>}
        btnTitle="변경하기"
        onChange={() => {
          onChangeMeetingReminderActive(true);
          setMeetingReminderActiveModal(false);
        }}
        modalIsOpen={meetingReminderActiveModal}
        closeModal={() => setMeetingReminderActiveModal(false)}
      />
      <AlertModal
        title={
          <p>
            예약 시작 전 알림을
            <br />
            비활성화하시겠습니까?
          </p>
        }
        content={
          <p style={{ textAlign: "center" }}>
            예약 시작 전, 참석자에게 사전 알림을
            <br />
            전송하지 않습니다.
          </p>
        }
        btnTitle="변경하기"
        onChange={() => {
          onChangeMeetingReminderActive(false);
          setMeetingReminderUnActiveModal(false);
        }}
        modalIsOpen={meetingReminderUnActiveModal}
        closeModal={() => setMeetingReminderUnActiveModal(false)}
      />
    </PolicyCustomizeSection>
  );
};

export default React.memo(PreMeetingNotificationSetting);
